<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0 popup-wrapper">
    <div class="popup-actions">
      <button mat-raised-button color="primary" (click)="$event.preventDefault(); popUpEndereco({}, true)">
        <mat-icon>add_location_alt</mat-icon>
        {{"ADD" | translate }} {{"ENDERECO" | translate }}
      </button>
    </div>

    <ng-container *ngIf="layoutConf?.isMobile; else desktopEnderecoTable">
      <div class="mobile-cards-wrap" *ngIf="enderecos?.length; else emptyEnderecoList">
        <mat-card class="mobile-card" *ngFor="let row of enderecos; let i = index">
          <div class="mobile-card-header">
            <div class="mobile-card-title">#{{ i + 1 }} - {{ row?.endereco || 'Endereço sem nome' }}</div>
            <div class="mobile-card-actions">
              <button mat-icon-button color="primary" matTooltip="Editar" (click)="$event.preventDefault(); popUpEndereco(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Excluir" (click)="$event.preventDefault(); deleteEndereco(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="mobile-card-grid">
            <div><span>CEP</span><strong>{{ row?.cep || '-' }}</strong></div>
            <div><span>Número</span><strong>{{ row?.numero || '-' }}</strong></div>
            <div><span>Bairro</span><strong>{{ row?.bairro || '-' }}</strong></div>
            <div><span>Cidade</span><strong>{{ row?.cadMun?.municipio || '-' }}{{ row?.cadMun?.uf ? ' - ' + row?.cadMun?.uf : '' }}</strong></div>
          </div>

          <div class="mobile-card-line" *ngIf="row?.complemento">
            <span>Complemento</span>
            <strong>{{ row?.complemento }}</strong>
          </div>
        </mat-card>
      </div>

      <mat-paginator
        class="mobile-paginator"
        #paginatorEndereco
        [length]="lengthEndereco"
        [showFirstLastButtons]="true"
        [pageSize]="pageSizeEndereco"
        [pageSizeOptions]="pageSizeOptionsEndereco"
        (page)="pageEventEndereco = setPageSizeOptionsEndereco($event)">
      </mat-paginator>
    </ng-container>

    <ng-template #desktopEnderecoTable>
      <ngx-datatable
        class="material ml-0 mr-0"
        [rows]="enderecos"
        [headerHeight]="50"
        [footerHeight]="50"
        [scrollbarH]="true"
        [messages]="{emptyMessage:'Nenhum Endereço encontrado'}"
        [limit]="pageSizeEndereco"
        [rowHeight]="50">
        <ngx-datatable-column name="#" [width]="25">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="$event.preventDefault(); popUpEndereco(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button mat-sm-button color="warn" (click)="$event.preventDefault(); deleteEndereco(row)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="CEP" [flexGrow]="1" [width]="120">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.cep }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Endereço" [flexGrow]="1" [width]="200">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.endereco }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Numero" [flexGrow]="1" [width]="75">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.numero }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Bairro" [flexGrow]="1" [width]="120">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.bairro }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cidade" [flexGrow]="1" [width]="200">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span *ngIf="row && row.cadMun">{{ row?.cadMun?.municipio + '-' + row?.cadMun?.uf }}</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <mat-paginator
              #paginatorEndereco
              [length]="lengthEndereco"
              fxLayoutAlign="space-around center"
              [showFirstLastButtons]="true"
              [pageSize]="pageSizeEndereco"
              [pageSizeOptions]="pageSizeOptionsEndereco"
              (page)="pageEventEndereco = setPageSizeOptionsEndereco($event)">
            </mat-paginator>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </ng-template>

    <ng-template #emptyEnderecoList>
      <div class="empty-state">Nenhum endereço encontrado.</div>
    </ng-template>
  </mat-card>
</div>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    {{"CLOSE" | translate }}
  </button>
</mat-dialog-actions>